import * as types from './notifications.actionTypes';

const initState = {
  unreadCount: 0,
  notifications: [],
  page: 1,
  lastPage: 1,
  chatUnreadCount: 0,
  isFetchingNotifications: false,
  isMarkingNotificationAsRead: false,
};

export default (state = initState, action) => {
  switch (action.type) {
    case types.FETCH_NOTIFICATIONS_REQUEST:
      return {
        ...state,
        isFetchingNotifications: true,
      };

    case types.FETCH_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        notifications: [
          ...state.notifications,
          ...action.notifications.data.map(el => ({ ...el.data, createdAt: el.created_at, read_at: el.read_at, sender: el.sender })),
        ],
        lastPage: action.notifications.meta.last_page,
        page: action.notifications.meta.current_page,
        isFetchingNotifications: false,
      };

    case types.FETCH_NOTIFICATIONS_FAILURE:
      return {
        ...state,
        isFetchingNotifications: false,
      };

    case types.NOTIFICATION_RECIEVED:
      return {
        ...state,
        notifications: [action.notification, ...state.notifications],
        unreadCount: state.unreadCount + 1,
      };

    case types.MARK_NOTIFICATION_AS_READ_REQUEST:
      return {
        ...state,
        isMarkingNotificationAsRead: true,
      };

    case types.MARK_NOTIFICATION_AS_READ_SUCCESS:
      return {
        ...state,
        isMarkingNotificationAsRead: false,
        notifications: state.notifications.map(notification => {
          if (notification.id === action.notification.id) {
            return {
              ...notification,
              readAt: action.notification.readAt,
            };
          }

          return notification;
        }),
      };

    case types.MARK_NOTIFICATION_AS_READ_FAILURE:
      return {
        ...state,
        isMarkingNotificationAsRead: false,
      };

    case types.RESET_UNREAD_COUNT:
      return {
        ...state,
        unreadCount: 0,
      };

    case types.RESET_NOTIFICATIONS:
      return {
        ...state,
        notifications: [],
        page: 1,
      };
    case types.SET_CHAT_UNREAD_COUNT:
      return {
        ...state,
        chatUnreadCount: action.count,
      };

    default:
      return state;
  }
};
